<template>
  <div class="cu-page-container">
    <!-- Contact Us 按钮（固定在右侧） -->
    <button 
      type="button" 
      id="cu-btn-contact-us" 
      class="cu-btn-contact-us cu-right-tool-bar-item cu-bg-purple cu-p-3 cu-mt-3"
      @click="toggleContactModal"
    >
      <img 
        src="https://cdn.adsalecdn.com/EMP/2-0/images/Chat.svg" 
        alt="chat" 
        class="cu-chat-icon"
      />
      <span class="cu-btn-text">Contact Us</span>
    </button>

    <!-- 遮罩层 -->
    <div 
      v-if="showModal" 
      class="cu-modal-backdrop cu-fade cu-show" 
      @click="closeContactModal"
    ></div>

    <!-- Contact Us 模态框 -->
    <div 
      id="cu-contact-us-modal" 
      class="cu-vanilla-modal"
      :class="{ 'cu-modal-open': showModal }"
    >
      <div class="cu-vanilla-modal-content">
        <!-- Loading 遮罩 -->
        <div class="cu-overlay-contact-us" v-if="loading" style="display: block;">
          <div class="cu-position-absolute cu-top-50 cu-start-50 cu-translate-middle">
            <div class="cu-spinner-border" role="status">
              <span class="cu-sr-only">Loading Data</span>
            </div>
          </div>
        </div>

        <!-- 表单 -->
        <form 
          id="cu-form-contact-us" 
          class="cu-form-contact-us"
          @submit.prevent="submitContactUs"
          style="overflow-y: auto;"
        >
          <!-- 隐藏字段 -->
          <input name="fid" id="cu-fid" :value="contactUsForm.fid" type="hidden">
          <input type="hidden" id="cu-hid-codepage" name="hid_codepage" :value="contactUsForm.hidCodepage">
          <input type="hidden" name="showcode" :value="contactUsForm.showcode">
          <input type="hidden" name="submitPageURL" :value="contactUsForm.submitPageURL">
          <input type="hidden" name="langid" :value="contactUsForm.langid">
          <input id="cu-captcha-ticket" name="captcha_ticket" type="text" hidden="">
          <input id="cu-captcha-randstr" name="captcha_randstr" type="text" hidden="">
          <input type="hidden" name="IsNewValidCode" :value="contactUsForm.IsNewValidCode">
          <input type="hidden" name="isNotNeedValidate" :value="contactUsForm.isNotNeedValidate">
          <input type="hidden" name="email_to" :value="contactUsForm.email_to">
          <input type="hidden" name="email_from" :value="contactUsForm.email_from">
          <input type="hidden" name="email_subject" :value="contactUsForm.email_subject">
          <input type="hidden" name="email_confirm_message" :value="contactUsForm.email_confirm_message">
          <input type="hidden" name="hdPrivacy" :value="contactUsForm.hdPrivacy ? 'true' : 'false'">
          <input type="hidden" name="hdShare" :value="contactUsForm.hdShare ? 'true' : 'false'">
          <input id="cu-captcha-verify-param" name="captchaVerifyParam" value="" type="hidden">
          <input name="showid" id="cu-showid" :value="contactUsForm.showid" type="hidden">
          <input name="isCloud" id="cu-is-cloud" value="true" type="hidden">
          <input type="hidden" name="ValType" id="cu-val-type" value="Geetest">
          <input id="cu-lot-number" name="lot_number" value="" type="hidden">
          <input id="cu-captcha-output" name="captcha_output" value="" type="hidden">
          <input id="cu-pass-token" name="pass_token" value="" type="hidden">
          <input id="cu-gen-time" name="gen_time" value="" type="hidden">
          <input id="cu-type-name" name="typename" value="" type="hidden">
          <input id="cu-is-aliyun-valid" name="IsAliyunValid" value="true" type="hidden">
          <input id="cu-referer-link" name="RefererLink" value="https://www.chinaplasonline.com/eMarketplace" type="hidden">

          <!-- 标题 -->
          <div class="cu-font-title cu-font-weight-bold cu-form-group">
            Contact Us<br>
          </div>

          <!-- 表单内容 -->
          <div class="cu-cps-form cu-contact-us-form-content">
            <div class="cu-cps-form-group">
              <!-- Reason 下拉 -->
              <div class="cu-contact-us-form-item">
                <select 
                  v-model="contactUsForm.Reason" 
                  id="cu-contact-us-reason" 
                  name="Reason"
                  class="cu-form-select"
                  @change="onReasonChange"
                  required
                >
                  <option value="">请选择</option>
                  <option 
                    v-for="item in reasonOptions" 
                    :key="item.value" 
                    :value="item.value"
                  >
                    {{ item.text }}
                  </option>
                </select>
                <label 
                  for="cu-contact-us-reason" 
                  class="cu-form-label cu-floating-label cu-floated-label"
                >
                  I would like to enquire about
                  <span class="cu-required">*</span>
                </label>
                <input 
                  name="ReasonText" 
                  id="cu-contact-us-reason-text" 
                  :value="contactUsForm.ReasonText" 
                  type="hidden" 
                  required
                >
              </div>

              <!-- Message 文本域 -->
              <div class="cu-cps-form-item">
                <textarea 
                  name="message" 
                  id="cu-message" 
                  v-model="contactUsForm.message"
                  class="cu-form-control cu-inputing" 
                  maxlength="350" 
                  required
                ></textarea>
                <label 
                  for="cu-message" 
                  class="cu-form-label cu-floating-label cu-floated-label"
                >
                  Message
                  <span class="cu-required">*</span>
                </label>
              </div>

              <!-- Name 输入框 -->
              <div class="cu-cps-form-item">
                <input 
                  type="text" 
                  id="cu-contact-us-name" 
                  name="name" 
                  v-model="contactUsForm.name"
                  class="cu-form-control" 
                  required
                >
                <label 
                  for="cu-contact-us-name" 
                  class="cu-form-label cu-floating-label cu-floated-label"
                >
                  Name
                  <span class="cu-required">*</span>
                </label>
              </div>

              <!-- Company 输入框 -->
              <div class="cu-cps-form-item">
                <input 
                  type="text" 
                  id="cu-contact-us-company" 
                  name="Company" 
                  v-model="contactUsForm.Company"
                  class="cu-form-control" 
                  required
                >
                <label 
                  for="cu-contact-us-company" 
                  class="cu-form-label cu-floating-label cu-floated-label"
                >
                  Company
                  <span class="cu-required">*</span>
                </label>
              </div>

              <!-- Country 下拉：统一使用 selection + vue-treeselect，与登录页国家选择风格一致 -->
              <div class="cu-contact-us-form-item">
                <selection
                  style="margin-bottom: 0px;"
                  :title="'Country / Region'"
                  label="Name"
                  class="mobile-country-select"
                  :value="contactUsForm.Country"
                  :options="selectionCountryOptions"
                  :ControlId="'cu-contact-us-country'"
                  :multiple="false"
                  @input="handleCountryCodeInput"
                  @fromChird_TreeSelected="handleCountrySelected($event)"
                >
                </selection>
                <input 
                  name="CountryText" 
                  id="cu-contact-us-country-text" 
                  :value="contactUsForm.CountryText" 
                  type="hidden" 
                  required
                >
              </div>

              <!-- Mobile 输入框 -->
              <div class="cu-cps-form-item">
                <input 
                  type="text" 
                  id="cu-contact-us-mobile" 
                  name="Mobile" 
                  v-model="contactUsForm.Mobile"
                  class="cu-form-control" 
                  @keyup="contactUsForm.Mobile = contactUsForm.Mobile.replace(/[^0-9]/g, '')"
                  required
                >
                <label 
                  for="cu-contact-us-mobile" 
                  class="cu-form-label cu-floating-label cu-floated-label"
                >
                  Mobile No.
                  <span class="cu-required">*</span>
                </label>
              </div>

              <!-- Email 输入框 -->
              <div class="cu-cps-form-item">
                <input 
                  type="email" 
                  id="cu-contact-us-email" 
                  name="Email" 
                  v-model="contactUsForm.Email"
                  class="cu-form-control" 
                  required
                >
                <label 
                  for="cu-contact-us-email" 
                  class="cu-form-label cu-floating-label cu-floated-label"
                >
                  Email
                  <span class="cu-required">*</span>
                </label>
              </div>
            </div>

            <!-- 必填字段提示 -->
            <div class="cu-lineheight cu-form-group">
              <span class="cu-font-red cu-note">* Mandatory Fields</span>
            </div>

            <!-- 隐私条款复选框 -->
            <div id="cu-pur-item-note" class="cu-pur-item-note">
              <div>
                <div class="cu-form-check">
                  <input 
                    class="cu-form-check-input" 
                    type="checkbox" 
                    value="" 
                    id="cu-chk-privacy" 
                    name="chkPrivacy"
                    v-model="contactUsForm.hdPrivacy"
                    required
                  >
                  <label class="cu-form-check-label cu-note" for="cu-chk-privacy">
                    I have read and agree to the 
                    <a 
                      target="_blank" 
                      href="/eMarketplace/privacy/eng" 
                      class="cu-link-text cu-font-red"
                    >
                      Privacy Policy
                    </a> 
                    and 
                    <a 
                      target="_blank" 
                      href="/eMarketplace/disclaimer/eng" 
                      class="cu-link-text cu-font-red"
                    >
                      Terms & Conditions of Uses
                    </a>.
                    <span class="cu-required">*</span>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <!-- 提交按钮 -->
          <div class="cu-mt-3">
            <button 
              id="cu-btn-submit-contact-us" 
              type="submit" 
              class="cu-btn cu-btn-red cu-m-auto cu-form-group cu-btn-submit-contact-us"
              :disabled="submitting"
            >
              {{ submitting ? '提交中...' : 'Submit' }}
            </button>
          </div>
        </form>
      </div>
    </div>

    <!-- 验证码组件 -->
    <GeetestCaptcha 
      ref="captchaInstance" 
      @captchaVerifyCallbackGeetest="handleCaptchaVerify"
      :currentUrlName="'contactUs'"
    />

    <!-- 成功提示弹框 -->
    <div 
      v-if="showSuccessModal" 
      class="cu-success-modal-backdrop"
      @click="closeSuccessModal"
    >
      <div class="cu-success-modal-dialog" @click.stop>
        <div class="modal-content msgModel-content border-light-grey">
          <div class="modal-header">
            <button 
              type="button" 
              class="close" 
              @click="closeSuccessModal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-title h5 msgModel-title pl-3 pr-3" style="margin:0px;" id="MsgModalLabel"></div>
          <div class="modal-body h6 msgModel-body pl-3 pr-3 mb-5" style="color: rgb(0, 0, 0);">
            谢谢您的查询，我们的客服人员会尽快与您联系。
          </div>
          <div class="modal-footer msgModel-footer text-center d-none">
            <a class="btn btn-red msgModel-button left-btn"></a>
            <a class="btn btn-red msgModel-button right-btn"></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ContactUsService } from '../../_services/ContactUsService';
import GeetestCaptcha from '../../components/GeetestCaptcha.vue';
import { sendFormEmail, CONTACT_US_EMAIL_CONFIG } from '../../components/new-login/Common/email-sender.js';
import {
  DEFAULT_LANG_ID,
  DEFAULT_SHOW_ID,
  DEFAULT_SHOW_CODE,
  getCurrentLangId,
  getContactUsConfig,
  SUBMIT_STATUS_CODE
} from '../../components/new-login/Common/new-login-config.js';
import { showGeetestCaptcha, handleCaptchaVerify } from '../../components/new-login/Common/captcha-helper.js';

// Country 数据直接从 CDN 获取，无需通过 ContactUsService

export default {
  name: 'ContactUs',
  components: {
    GeetestCaptcha
  },
  data() {
    return {
      showModal: false,
      loading: false,
      submitting: false,
      showSuccessModal: false,
      captchaData: null,
      captchaTimeout: null, // 验证码超时定时器
      
      // 语言和配置
      langId: DEFAULT_LANG_ID, // 从路由或配置中获取，默认英文
      showId: DEFAULT_SHOW_ID,
      showCode: DEFAULT_SHOW_CODE,
      headerType: 'Buyers', // 'Buyers' 或 'Suppliers'
      
      // Reason 下拉数据
      reasonOptions: [],
      
      // Country 下拉数据
      countryOptions: [],
      
      // ContactUs 表单数据
      contactUsForm: {
        fid: getContactUsConfig('supplier').fid, // 默认供应商，会在 created 中根据 headerType 更新
        hidCodepage: String(DEFAULT_LANG_ID),
        showid: DEFAULT_SHOW_ID,
        showcode: DEFAULT_SHOW_CODE,
        langid: DEFAULT_LANG_ID,
        Reason: null,
        ReasonText: '',
        message: '',
        name: '',
        Company: '',
        Country: '',
        CountryText: '',
        Mobile: '',
        Email: '',
        hdPrivacy: false,
        hdShare: true,
        captchaVerifyParam: '',
        submitPageURL: 'idx',
        IsNewValidCode: 'true',
        isNotNeedValidate: 'false', // 设置为 false 以强制验证码验证
        email_to: CONTACT_US_EMAIL_CONFIG.email_to,
        email_from: CONTACT_US_EMAIL_CONFIG.email_from,
        email_subject: CONTACT_US_EMAIL_CONFIG.email_subject,
        email_confirm_message: CONTACT_US_EMAIL_CONFIG.email_confirm_message
      }
    };
  },
  created() {
    this.loadReasons();
    this.loadCountries();
    
    // 根据 headerType 设置 fid
    const userType = this.headerType === 'Suppliers' ? 'supplier' : 'buyer';
    const contactUsConfig = getContactUsConfig(userType);
    this.contactUsForm.fid = contactUsConfig.fid;
    this.contactUsForm.showid = contactUsConfig.showid || DEFAULT_SHOW_ID;
    this.contactUsForm.showcode = contactUsConfig.showcode || DEFAULT_SHOW_CODE;
    this.contactUsForm.submitPageURL = contactUsConfig.submitPageURL;
  },
  computed: {
    // 供 selection 组件使用的国家选项（id/label 结构），与登录页国家选择保持一致
    selectionCountryOptions() {
      if (this.countryOptions && this.countryOptions.length > 0) {
        return this.countryOptions.map(option => ({
          id: option.value,
          label: option.text
        }));
      }
      return [];
    }
  },
  methods: {
    /**
     * 加载查询原因下拉
     */
    async loadReasons() {
      this.loading = true;
      try {
        const role = this.headerType === 'Suppliers' ? 'suppliers' : 'buyers';
        const response = await ContactUsService.GetReasons(role);
        
        if (response && response.isSuccessful === true && response.data) {
          this.reasonOptions = response.data || [];
        } else {
          this.reasonOptions = [];
        }
      } catch (error) {
        this.reasonOptions = [];
      } finally {
        this.loading = false;
      }
    },
    
    /**
     * 加载国家下拉（使用统一的国家加载工具函数）
     */
    async loadCountries() {
      this.loading = true;
      try {
        const { loadCountryOptions } = await import('../../components/new-login/Common/country-loader.js');
        this.countryOptions = await loadCountryOptions(this.langId);
      } catch (error) {
        this.countryOptions = [];
      } finally {
        this.loading = false;
      }
    },
    
    /**
     * Reason 下拉变化时，更新 ReasonText
     */
    onReasonChange() {
      const selected = this.reasonOptions.find(r => r.value === this.contactUsForm.Reason);
      this.contactUsForm.ReasonText = selected ? selected.text : '';
    },
    
    /**
     * Country 下拉变化时，更新 CountryText（兼容旧逻辑）
     */
    onCountryChange() {
      const selected = this.countryOptions.find(c => c.value === this.contactUsForm.Country);
      this.contactUsForm.CountryText = selected ? selected.text : '';
      this.contactUsForm.Country = selected ? selected.value : '';
    },
    // 与登录页国家选择保持一致的事件处理（selection 组件）
    handleCountryCodeInput(value) {
      const selected = this.countryOptions.find(c => c.value === value);
      this.contactUsForm.Country = value;
      this.contactUsForm.CountryText = selected ? selected.text : '';
    },
    handleCountrySelected(obj) {
      const value = obj && obj.id;
      const selected = this.countryOptions.find(c => c.value === value);
      this.contactUsForm.Country = value;
      this.contactUsForm.CountryText = selected ? selected.text : '';
    },
    
    /**
     * 切换模态框显示/隐藏
     */
    toggleContactModal() {
      this.showModal = !this.showModal;
      if (this.showModal) {
        document.body.classList.add('cu-modal-open');
        // 移动按钮到模态框左边，避免被遮挡
        const btn = document.getElementById('cu-btn-contact-us');
        if (btn) {
          // 直接设置right值，使用CSS transition
          btn.style.right = '450px';
        }
      } else {
        document.body.classList.remove('cu-modal-open');
        // 恢复按钮位置
        const btn = document.getElementById('cu-btn-contact-us');
        if (btn) {
          btn.style.right = '0px';
        }
      }
    },
    
    /**
     * 关闭模态框
     */
    closeContactModal() {
      this.showModal = false;
      document.body.classList.remove('cu-modal-open');
      // 恢复按钮位置
      const btn = document.getElementById('cu-btn-contact-us');
      if (btn) {
        btn.style.right = '0px';
      }
    },
    

    /**
     * 提交 ContactUs 表单（先显示验证码，验证通过后再提交）
     */
    async submitContactUs(event) {
      // 阻止表单默认提交行为
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      
      // 如果已经在提交中，直接返回
      if (this.submitting) {
        return false;
      }
      
      // 表单验证
      const form = document.getElementById('cu-form-contact-us');
      if (!form || !form.checkValidity()) {
        if (form) {
          form.reportValidity();
        }
        return false;
      }
      
      // 验证邮箱格式
      if (!validateEmail(this.contactUsForm.Email)) {
        alert('Invalid format of email address');
        return false;
      }
      
      // 去除邮箱空格
      this.contactUsForm.Email = this.contactUsForm.Email.replaceAll(' ', '');
      
      // 显示 loading 和验证码
      this.submitting = true;
      this.loading = true;
      
      await this.$nextTick();
      
      setTimeout(() => {
        this.showCaptcha();
      }, 100);
      
      return false;
    },

    /**
     * 显示验证码
     */
    showCaptcha() {
      // 清除之前的超时定时器
      if (this.captchaTimeout) {
        clearTimeout(this.captchaTimeout);
        this.captchaTimeout = null;
      }
      
      // 使用统一的验证码显示方法
      showGeetestCaptcha(
        this,
        'captchaInstance',
        () => {
          // 验证成功后的回调（由 handleCaptchaVerify 处理）
        },
        (error) => {
          alert(error);
          this.loading = false;
          this.submitting = false;
        }
      );
      
      // 设置超时：如果 5 分钟内没有验证，重置状态（防止用户关闭验证码后状态卡住）
      this.captchaTimeout = setTimeout(() => {
        this.loading = false;
        this.submitting = false;
        this.captchaTimeout = null;
      }, 5 * 60 * 1000); // 5 分钟
    },

    /**
     * 处理验证码验证成功回调
     */
    async handleCaptchaVerify(captchaVerifyParam, resolve) {
      // 使用统一的验证码处理函数
      const isValid = handleCaptchaVerify(this, captchaVerifyParam, resolve);
      if (!isValid) {
        return;
      }
      
      // 清除超时定时器
      if (this.captchaTimeout) {
        clearTimeout(this.captchaTimeout);
        this.captchaTimeout = null;
      }
      
      this.captchaData = captchaVerifyParam;
      
      // 更新表单中的验证码字段
      this.contactUsForm.captchaVerifyParam = JSON.stringify(captchaVerifyParam);
      
      // 更新隐藏字段
      if (captchaVerifyParam) {
        const lotNumberInput = document.getElementById('cu-lot-number');
        const captchaOutputInput = document.getElementById('cu-captcha-output');
        const passTokenInput = document.getElementById('cu-pass-token');
        const genTimeInput = document.getElementById('cu-gen-time');
        
        if (lotNumberInput) lotNumberInput.value = captchaVerifyParam.lot_number || '';
        if (captchaOutputInput) captchaOutputInput.value = captchaVerifyParam.captcha_output || '';
        if (passTokenInput) passTokenInput.value = captchaVerifyParam.pass_token || '';
        if (genTimeInput) genTimeInput.value = captchaVerifyParam.gen_time || '';
      }
      
      // 调用 resolve 让验证码组件知道验证成功
      if (resolve) {
        resolve(true);
      }
      
      // 执行实际提交
      await this.doSubmit();
    },

    /**
     * 执行实际提交
     */
    async doSubmit() {
      try {
        // 构建表单数据
        const formDataToSend = {
          fid: this.contactUsForm.fid,
          showid: this.contactUsForm.showid,
          showcode: this.contactUsForm.showcode,
          langid: this.contactUsForm.langid,
          hidCodepage: this.contactUsForm.hidCodepage || String(this.contactUsForm.langid) || '1252',
          submitPageURL: this.contactUsForm.submitPageURL,
          IsNewValidCode: this.contactUsForm.IsNewValidCode,
          isNotNeedValidate: this.contactUsForm.isNotNeedValidate,
          captchaVerifyParam: this.contactUsForm.captchaVerifyParam,
          // Contact Us 表单字段
          Reason: this.contactUsForm.Reason,
          ReasonText: this.contactUsForm.ReasonText,
          message: this.contactUsForm.message,
          name: this.contactUsForm.name,
          Company: this.contactUsForm.Company,
          Country: this.contactUsForm.Country,
          CountryText: this.contactUsForm.CountryText,
          Mobile: this.contactUsForm.Mobile,
          Email: this.contactUsForm.Email,
          hdPrivacy: this.contactUsForm.hdPrivacy,
          hdShare: this.contactUsForm.hdShare
        };
        
        // 邮件配置
        const emailConfig = {
          email_to: this.contactUsForm.email_to,
          email_from: this.contactUsForm.email_from,
          email_subject: this.contactUsForm.email_subject,
          email_confirm_message: this.contactUsForm.email_confirm_message
        };
        
        // 发送邮件
        const result = await sendFormEmail({
          formData: formDataToSend,
          captchaData: this.captchaData,
          emailConfig: emailConfig,
          formType: 'contact-us'
        });
        
        // 处理返回结果
        if (result.statusCode === SUBMIT_STATUS_CODE.CAPTCHA_FAILED) {
          alert('验证码验证失败');
          this.loading = false;
          this.submitting = false;
        } else if (result.statusCode === SUBMIT_STATUS_CODE.VALIDATION_ERROR) {
          let msg = '';
          if (result.Msg && result.Msg.length > 0) {
            msg = result.Msg.join(',');
          }
          alert('以下数据不能为空: ' + msg);
          this.loading = false;
          this.submitting = false;
        } else if (result.statusCode === SUBMIT_STATUS_CODE.SUCCESS) {
          // 提交成功，显示成功弹框
          this.loading = false;
          this.submitting = false;
          this.showSuccessModal = true;
          this.resetForm();
          // 不关闭联系表单，让用户可以看到成功提示
        } else {
          this.loading = false;
          this.submitting = false;
        }
      } catch (error) {
        alert('提交失败，请稍后重试');
        this.loading = false;
        this.submitting = false;
      }
    },

    /**
     * 关闭成功弹框
     */
    closeSuccessModal() {
      this.showSuccessModal = false;
      this.closeContactModal();
    },
    
    /**
     * 重置表单
     */
    resetForm() {
      const userType = this.headerType === 'Suppliers' ? 'supplier' : 'buyer';
      const contactUsConfig = getContactUsConfig(userType);
      this.contactUsForm = {
        fid: contactUsConfig.fid,
        hidCodepage: String(getCurrentLangId()),
        showid: contactUsConfig.showid || DEFAULT_SHOW_ID,
        showcode: contactUsConfig.showcode || DEFAULT_SHOW_CODE,
        langid: getCurrentLangId(),
        Reason: null,
        ReasonText: '',
        message: '',
        name: '',
        Company: '',
        Country: '',
        CountryText: '',
        Mobile: '',
        Email: '',
        hdPrivacy: false,
        hdShare: true,
        captchaVerifyParam: '',
        submitPageURL: 'idx',
        IsNewValidCode: 'true',
        isNotNeedValidate: 'false', // 设置为 false 以强制验证码验证
        email_to: CONTACT_US_EMAIL_CONFIG.email_to,
        email_from: CONTACT_US_EMAIL_CONFIG.email_from,
        email_subject: CONTACT_US_EMAIL_CONFIG.email_subject,
        email_confirm_message: CONTACT_US_EMAIL_CONFIG.email_confirm_message
      };
    }
  }
};
</script>

<style scoped>
/* ==================== Contact Us 页面样式 ==================== */
/* 使用 cu- 前缀避免与系统样式冲突 */

.cu-page-container {
  position: relative;
  z-index: 1041;
}

/* Contact Us 按钮 */
.cu-btn-contact-us {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 60px;
  height: 90px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: #5D4D8C;
  color: white;
  padding: 1rem !important;
  margin: 0 !important;
  border-radius: 5px 0 0 5px;
  border: none;
  cursor: pointer;
  z-index: 1041;
  box-sizing: border-box;
  transition: right 0.3s linear;
}

.cu-btn-contact-us:hover {
  background: #4a3d6f;
}

.cu-chat-icon {
  margin: auto;
  display: block;
  max-width: none !important;
  margin-left: 5px;
  margin-right: 5px;
  margin-bottom: 0;
}

.cu-btn-text {
  width: calc(100% + 30px);
  white-space: initial;
  margin-bottom: 0;
  font-size: 14px;
}

/* 遮罩层 */
.cu-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
  opacity: 0;
  transition: opacity 0.15s linear;
}

.cu-modal-backdrop.cu-show {
  opacity: 0.5;
}

/* 模态框 */
.cu-vanilla-modal {
  position: fixed;
  margin: 0;
  width: 450px;
  transform: translate3d(0%, 0, 0);
  border-radius: 5px 0 0 5px;
  right: -450px;
  top: 120px;
  background: #F8F8F8;
  padding: 25px 30px;
  z-index: 1041;
  transition: right 0.3s linear;
  box-sizing: border-box;
}

.cu-vanilla-modal.cu-modal-open {
  right: 0;
}

.cu-vanilla-modal-content {
  position: relative;
}

/* Loading 遮罩 */
.cu-overlay-contact-us {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  z-index: 10;
  display: none;
}

.cu-position-absolute {
  position: absolute;
}

.cu-top-50 {
  top: 50%;
}

.cu-start-50 {
  left: 50%;
}

.cu-translate-middle {
  transform: translate(-50%, -50%);
}

.cu-spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: text-bottom;
  border: 0.25em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: cu-spinner-border 0.75s linear infinite;
}

@keyframes cu-spinner-border {
  to {
    transform: rotate(360deg);
  }
}

.cu-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

/* 表单样式 */
.cu-form-contact-us {
  /* 取消高度限制与内部滚动条，让表单根据内容自然撑开 */
  max-height: none;
  overflow-y: visible;
}

.cu-font-title {
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

.cu-font-weight-bold {
  font-weight: 700;
}

.cu-form-group {
  margin-bottom: 1rem;
}

.cu-cps-form {
  margin-bottom: 1rem;
}

.cu-cps-form-group {
  margin-bottom: 1rem;
}

.cu-contact-us-form-item,
.cu-cps-form-item {
  margin-bottom: 1.5rem;
  position: relative;
}

.cu-form-select,
.cu-form-control {
  width: 100%;
  padding: 8px 12px;
  padding-top: 14px;
  border: 1px solid rgba(0, 0, 0, 0.23);
  border-radius: 4px;
  font-size: 14px;
  font-family: 'Inter', 'Roboto', Arial, sans-serif;
  background: white;
  box-sizing: border-box;
}

.cu-form-control {
  height: 40px;
}

.cu-form-control.cu-inputing {
  min-height: 100px;
  padding-top: 20px;
  resize: vertical;
}

.cu-form-select:focus,
.cu-form-control:focus {
  outline: none;
  border-color: #7366FF;
}

.cu-form-label {
  display: block;
  margin-bottom: 5px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.80);
  font-family: 'Inter', 'Roboto', Arial, sans-serif;
}

/* 浮动标签样式 - 默认就在输入框的上边框内 */
.cu-floating-label {
  position: absolute;
  pointer-events: none;
  left: 12px;
  top: -8px;
  padding: 0 5px;
  background-color: #fff;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
  z-index: 2;
  color: rgba(0, 0, 0, 0.87);
  margin-bottom: 0;
  font-size: 12px;
  border-radius: 0.25rem;
}

.cu-floating-label.cu-floated-label {
  background-color: #fff;
  top: -8px;
  left: 12px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.87);
  border-radius: 0.25rem;
}

.cu-required {
  color: #CD1515;
  margin-left: 2px;
}

.cu-lineheight {
  line-height: 1.5;
}

.cu-font-red {
  color: #CD1515;
}

.cu-note {
  font-size: 12px;
}

.cu-pur-item-note {
  padding-left: 2px;
  padding-right: 10px;
}

.cu-form-check {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.cu-form-check-input {
  margin-top: 2px;
  cursor: pointer;
}

.cu-form-check-label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.80);
  cursor: pointer;
}

.cu-link-text {
  text-decoration: underline !important;
  color: #CD1515;
}

.cu-link-text:hover {
  color: #a01010;
}

.cu-mt-3 {
  margin-top: 1rem !important;
}

.cu-btn {
  padding: 8px 24px;
  height: 35px;
  font-size: 14px;
  display: flex;
  align-items: center;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  transition: background 0.3s;
}

.cu-btn-red {
  background: #dc3545;
  color: white;
}

.cu-btn-red:hover:not(:disabled) {
  background: #c82333;
}

.cu-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.cu-m-auto {
  margin: 0 auto;
}

/* 响应式 */
@media (max-width: 768px) {
  .cu-vanilla-modal {
    width: 100%;
    right: -100%;
    top: 0;
    height: 100vh;
    border-radius: 0;
  }
  
  .cu-vanilla-modal.cu-modal-open {
    right: 0;
  }
  
  .cu-btn-contact-us {
    width: 50px;
    height: 70px;
    font-size: 12px;
  }
}

/* 工具类 */
.cu-p-3 {
  padding: 1rem !important;
}

.cu-bg-purple {
  background: #5D4D8C;
  color: white;
}

.cu-right-tool-bar-item {
  width: 60px;
  height: 90px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

body.cu-modal-open {
  overflow: hidden;
}

/* 成功弹框样式 */
.cu-success-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.cu-success-modal-dialog {
  position: relative;
  width: auto;
  margin: 0.5rem;
  pointer-events: auto;
  max-width: 500px;
  width: 90%;
}

.msgModel-content {
  border-radius: 0;
  border: none;
}

.border-light-grey {
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  border-radius: 5px !important;
}

.modal-content {
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
  outline: 0;
}

.modal-header {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: start;
  align-items: flex-start;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding: 1rem;
  border-bottom: 1px solid #dee2e6;
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
}

.modal-header .close {
  padding: 1rem;
  margin: -1rem -1rem -1rem auto;
  background: transparent;
  border: 0;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  opacity: 0.5;
  cursor: pointer;
}

.modal-header .close:hover {
  opacity: 0.75;
}

.modal-title {
  margin-bottom: 0;
  line-height: 1.5;
  font-size: 1.25rem;
  font-weight: 500;
}

.modal-body {
  position: relative;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  padding: 1rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

.modal-footer {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: end;
  justify-content: flex-end;
  padding: 0.75rem;
  border-top: 1px solid #dee2e6;
  border-bottom-right-radius: calc(0.3rem - 1px);
  border-bottom-left-radius: calc(0.3rem - 1px);
}

.pl-3 {
  padding-left: 1rem !important;
}

.pr-3 {
  padding-right: 1rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.h5 {
  font-size: 1.25rem;
}

.h6 {
  font-size: 1rem;
}

.text-center {
  text-align: center !important;
}

.d-none {
  display: none !important;
}
</style>


